"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTypography = exports.StyledParagraph = exports.StyledP = exports.HeadingDiv = exports.BodyDiv = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _utils = require("../lib/utils");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledP = _styledComponents["default"].p(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 24px;\n  &.regular {\n    ", ";\n  }\n  &.semibold {\n    ", ";\n  }\n  &.medium {\n    ", ";\n  }\n"])), function (props) {
  return props.theme.typography.fontFamily.regular;
}, function (props) {
  return props.theme.typography.fontFamily.semibold;
}, function (props) {
  return props.theme.typography.fontFamily.medium;
});

exports.StyledP = StyledP;
var commonStyle = (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  font-weight: ", ";\n  font-style: ", ";\n  text-decoration: ", ";\n  color: ", ";\n"])), function (props) {
  return (0, _utils.getTypoWeight)(props.fontWeight)(props);
}, function (props) {
  return props.isItalic ? 'italic' : 'normal';
}, function (props) {
  return (0, _utils.getTypoStyle)(props.fontDecoration)(props);
}, function (props) {
  return props.color;
});
var bodyStyle = (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: ", "px;\n  line-height: ", "px;\n  ", ";\n"])), function (props) {
  return (0, _utils.getTypoSize)('body', props.size, 'size')(props);
}, function (props) {
  return (0, _utils.getTypoSize)('body', props.size, 'lineHeight')(props);
}, commonStyle);
var headingStyle = (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: ", "px;\n  line-height: ", "px;\n  ", ";\n"])), function (props) {
  return (0, _utils.getTypoSize)('heading', props.size, 'size')(props);
}, function (props) {
  return (0, _utils.getTypoSize)('heading', props.size, 'lineHeight')(props);
}, commonStyle);

var BodyDiv = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n"])), bodyStyle, commonStyle);

exports.BodyDiv = BodyDiv;

var HeadingDiv = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n"])), headingStyle, commonStyle);

exports.HeadingDiv = HeadingDiv;

var StyledParagraph = _styledComponents["default"].p(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n"])), function (props) {
  return (0, _utils.getTypography)('bodyRegular')(props);
}, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
});

exports.StyledParagraph = StyledParagraph;

var StyledTypography = _styledComponents["default"].p(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n  color: ", ";\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  return (0, _utils.getTypography)(props.variant)(props);
}, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
}, function (props) {
  return props.color && props.shade ? (0, _utils.getPalette)(props.color, props.shade)(props) : props.color;
}, function (props) {
  return props.ellipsis && "\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  ";
}, _styledSystem.space, _styledSystem.width);

exports.StyledTypography = StyledTypography;